"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_healthy__living__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "healthy-living-hi"), /*#__PURE__*/React.createElement("g", {
    id: "72278dfb-fc8d-4810-a115-0f46739901e3",
    "data-name": "healthy-living-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "53dc7fa9-5b8d-42e0-92e0-99dd9a12fa8e",
    "data-name": "Cloud_upload_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "209c0ec4-fb89-4959-9a13-96f7a90480d5",
    "data-name": "Calls_Contacts_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8d7cab64-e992-4e60-a7f5-ff9d5e650fab",
    "data-name": "PayG_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e0f172b4-3a75-4713-8267-ede9b3f2fcb8",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a528e803-d489-49db-85f6-b8625c8a41b8",
    "data-name": "My_Vodafone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "888570c6-4d0b-494f-a96a-8d83147b6f53",
    "data-name": "Settings_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "81853c4d-661a-4ff0-a6e9-5010dd9abc2f",
    "data-name": "User_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9ca11eed-1b19-430f-81f4-c9edc27fd577",
    "data-name": "Video_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4add6d03-dc6a-49bd-8d3d-6d2d33f14d99",
    "data-name": "Tutorials_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c1056ed4-fd09-4cf4-bd4e-5d2fa533ee99",
    "data-name": "Community_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cc710075-84e1-47a6-a77d-68fcb5409a28",
    "data-name": "Entertainment_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "15103a98-3d3e-435e-8f99-ead6ff96f83f",
    "data-name": "Insurance_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e391f3a4-079c-4ef3-ad18-c32ed02fe51a",
    "data-name": "Photos_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2052c9ff-8b9c-4f48-9c4e-a0eb9e37b951",
    "data-name": "Pie_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bb17cb53-f95c-4280-b6e6-f74affe33b2e",
    "data-name": "Shopping_trolley_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "de6487e3-9b0b-4f60-b2b9-04a7d497a093",
    "data-name": "Business_phone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "051e7828-a4f3-4f40-adcf-5cee4fba8953",
    "data-name": "Bundles_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b7dbb9ef-79c9-42e7-902d-ac937742740f",
    "data-name": "Customer_care_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c1a3ef69-2b15-47e5-9c0d-cd312908b395",
    "data-name": "Minutes_sms_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4dfe7953-3f0e-4aaa-adbd-4d97e0903316",
    "data-name": "Bar_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4baf01aa-d282-496b-9954-3cb3aeb4fd96",
    "data-name": "Line_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3c705dd5-98d1-4239-bb3c-83f83dd81d1b",
    "data-name": "Blog_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "30e2e4e7-cf60-4786-b789-6579fe5e76c8",
    "data-name": "SoHo_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1a26c171-042d-4147-9a5d-84f3f96d9e0e",
    "data-name": "SME_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "53028a9f-3cb3-46d6-b325-4294e598bff5",
    "data-name": "Public_sector_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "631f46f3-b71f-454c-b0d4-60faaf108a71",
    "data-name": "Extras_services_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "174d0b6e-f4c4-49d1-bffe-16fe668a8d11",
    "data-name": "<Gruppe>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96,176a4,4,0,0,1-2.48-.86A319.56,319.56,0,0,1,56.37,139.4C31.16,110.91,17.6,84.78,16.07,61.75a41.11,41.11,0,0,1,11.36-31A46.62,46.62,0,0,1,61.35,16,45.12,45.12,0,0,1,97.07,33.7,43.59,43.59,0,0,1,131.73,16c24.33,0,44.13,20.76,44.21,46.31.28,3.95,1.61,49.95-77.45,112.82A4,4,0,0,1,96,176Z",
    fill: "#e60000"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M98.49,173.13a4,4,0,0,1-5,0A319.63,319.63,0,0,1,56.37,137.4C31.16,108.91,17.6,82.78,16.07,59.75c0-.56-.05-1.11-.07-1.67,0,1.22,0,2.44.07,3.67,1.53,23,15.09,49.16,40.3,77.66a319.63,319.63,0,0,0,37.16,35.74,4,4,0,0,0,5,0C174.87,114.4,176.21,69.41,176,62.86,175.63,74,169.38,116.76,98.49,173.13Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  })))))))))))))))))))))))))))));
}

var _default = ic_healthy__living__dark;
exports.default = _default;